module.exports = __webpack_public_path__ + "img/17.43908a77.jpg";